/**
 * configuration applied when BROCOLI_API_MODE = production
 */
module.exports = {}
